import axiosHelper from '../utils/axios';

export default (() => {
  const accessPath = '/access';
  const notificationsPath = `${accessPath}/notifications`;

	let activeNotificationsPromise;
	let activeNotificationsCache;

  async function getActiveNotifications() {
		if (activeNotificationsCache) {
			return activeNotificationsCache;
		}
		if (activeNotificationsPromise) {
			return activeNotificationsPromise;
		}

		activeNotificationsPromise = axiosHelper
			.getAccess('hideLoadingIndicator')
			.get(`${accessPath}/notifications`)
			.then(r => {
				activeNotificationsCache = r.data;
				return activeNotificationsCache;
			})
			.catch(err => {
				activeNotificationsPromise = null;
				throw err;
			});

		return activeNotificationsPromise;
  }

  async function getUnreadCount() {
    const response = await axiosHelper
      .getAccess('hideLoadingIndicator')
      .get(`${notificationsPath}/me/unread-count`);
    return response.data.unreadCount || 0;
  }

  async function getUnreadNotifications() {
    const response = await axiosHelper
      .getAccess('hideLoadingIndicator')
      .get(`${notificationsPath}/me/unread`);
    return response.data || [];
  }

  // UX: for now ACTIVE maps to backend "unread" endpoint
  async function getActiveNotificationsForMe() {
    return getUnreadNotifications();
  }

  async function getHistoryNotifications() {
    const response = await axiosHelper
      .getAccess('hideLoadingIndicator')
      .get(`${notificationsPath}/me/history`);
    return response.data || [];
  }

  async function markNotificationRead(notificationId) {
    const response = await axiosHelper
      .getAccess('hideLoadingIndicator')
      .put(`${notificationsPath}/${notificationId}/read`);
    return response.data;
  }

  async function dismissNotification(notificationId) {
    const response = await axiosHelper
      .getAccess('hideLoadingIndicator')
      .put(`${notificationsPath}/${notificationId}/dismiss`);
    return response.data;
  }

  async function markAllSeen() {
    try {
      const response = await axiosHelper
        .getAccess('hideLoadingIndicator')
        .put(`${notificationsPath}/me/mark-seen`);
      return response.data;
    } catch (err) {
      // Backend may return 409 when already seen; treat as success for UX
      const status = err?.response?.status || err?.status;
      if (status === 409) {
        return null;
      }
      throw err;
    }
  }

  return {
    getActiveNotifications,
    getUnreadCount,
    getUnreadNotifications,
    getActiveNotificationsForMe,
    getHistoryNotifications,
    markNotificationRead,
    dismissNotification,
    markAllSeen,
  };
})();
